import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, login, loading } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (!loading && user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    try {
      setSubmitting(true);
      await login(email, password);
      toast.success("Signed in");
      nav("/admin");
    } catch (err) {
      const msg = err?.response?.data?.detail;
      toast.error(typeof msg === "string" ? msg : "Sign in failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="min-h-screen bg-ink text-ivory flex items-center justify-center px-6" data-testid="admin-login">
      <form onSubmit={submit} className="w-full max-w-md border border-ivory/15 p-10">
        <img
          src="/brand/oereshaus-white.webp"
          alt="Oereshaus"
          className="w-40 h-auto object-contain mb-8"
        />
        <p className="label-mono opacity-60">Admin</p>
        <h1 className="mt-3 font-editorial text-5xl">Sign in.</h1>
        <div className="mt-8 space-y-6">
          <div>
            <label className="label-mono opacity-60">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="editorial-input on-dark"
              data-testid="admin-login-email"
            />
          </div>
          <div>
            <label className="label-mono opacity-60">Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="editorial-input on-dark"
              data-testid="admin-login-password"
            />
          </div>
        </div>
        <button
          type="submit"
          disabled={submitting}
          className="btn-outline-ivory mt-10 w-full justify-center"
          data-testid="admin-login-submit"
        >
          {submitting ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </main>
  );
}
